import { isArray as _isArray, isEqual as _isEqual } from 'lodash-es';
import { FilterType, FilterValue } from '@/models';
import { ActiveFilter, FilterState } from '@/types/filter';

const isFilterExcluded = (filterKey: FilterType) =>
  [FilterType.DATE_RANGE, FilterType.COMPARISON_PERIOD, FilterType.SINGLE_DATE].includes(filterKey);

export function countAppliedFilters<T extends object>(filterGroups: T): number {
  return Object.values(filterGroups).reduce((count, filters) => {
    if (!filters) return count;

    if (Array.isArray(filters)) {
      return count + (filters.length > 0 ? 1 : 0);
    }

    return count + 1;
  }, 0);
}

export const getActiveFilters = (state: FilterState, defaultState: FilterState): ActiveFilter[] => {
  return Object.entries(state)
    .filter(
      ([key, value]: [string, FilterValue]) =>
        !isFilterExcluded(key as FilterType) && !_isEqual(value, defaultState[key as FilterType]) && value !== false,
    )
    .flatMap(([key, value]: [string, FilterValue]) =>
      _isArray(value)
        ? value.map(filterValue => ({ key: key as FilterType, value: filterValue }))
        : { key: key as FilterType, value },
    );
};
